import {useContext, useEffect} from "react";
import CarouselSlider from "./sections/carouselSlider";
import LatestNews from "./sections/latestNews";
import Services from "./sections/services";
import Notices from "./sections/notices";
import Stakeholders from "./sections/stakeholders";
import {ShowLayoutContext} from "../../context/showLayoutContext";
import '../../assets/css/pages/home/style.scss'
import VisitorCounter from "./sections/visitorCounter";

const Index = () => {
    const [, setIsInLoginPage] = useContext(ShowLayoutContext);
    useEffect(() => {
        setIsInLoginPage(false);
    }, []);
    return (
        <>
            <CarouselSlider/>
            <LatestNews/>
            <Services/>
            <Notices/>
            <Stakeholders/>
            <VisitorCounter/>
        </>
    );
};

export default Index;
